/**
 * @providesModule mobxStoresX
 */
import { spy } from 'mobx';
import { models } from './config';

// rootStore可以使用bindEvents的声明周期和react的声明周期
export default class RootStore {
    constructor() {
        // 实例化stores
        Object.keys(models).forEach(name => {
            // 传入this是为了多个store间通信
            this[name] = new models[name](this);
        });
        console.log('rootStore', this)
    }

    componentWillUnmount() {
        try {
            Object.values(this).forEach(store => {
                if (store && store.$reaction) {
                    Object.values(store.$reaction).forEach(reaction => reaction());
                }
            });
        } catch (e) {
            reportScriptError(e);
            console.warn('Dispose store error ', e);
        }
    }
}

// 开发环境打印mobx日志
global.__QRN_DEV__ && spy(event => {
    const { dateFormat } = require('../common/DateUtils').default;
    try {
        if (event.type === 'action'
            && event.name && !event.name.startsWith('Reaction@')
            && !event.name.startsWith('<')) {
            const modelName = event.object.constructor.name,
                timeStamp = dateFormat(new Date(), 'hh:mm:ss');
            console.log(
                `Mobx action [${timeStamp}] %c${modelName}.${event.name}`,
                'color: #f44343;',
                'with args: ', event.arguments
            );
        }
    } catch (e) {
        reportScriptError(e);
    }
});
